export default {"src":"/_next/static/media/ftIcon3.f291ae2e.svg","height":66,"width":68};